let dict = {
  orderStatus: [
    { label: "已付款", value: "PAY" },
    { label: "已完成", value: "COMPLETED" },
    { label: "已取消", value: "CANCELED" },
    { label: "退款中", value: "REFUNDING" },
  ],
  foodState: {
    true: '上架中',
    false: '已下架',
  }
};

// module.exports = dict  --> 导入的时候可以 import { orderStatus } from "@/plugin/dict"。  export default dict的方式则不行
module.exports = dict;